import { z } from 'zod'

/** decoded program instructions */
const instructionDecodedSchema = z.object({
  programId: z.string(),
  program: z.string(),
  stackHeight: z.number().nullable(),
  parsed: z.object({
    info: z.record(z.unknown()),
    type: z.string(),
  }),
})

/** un-decoded program instructions */
const instructionUndecodedSchema = z.object({
  programId: z.string(),
  accounts: z.array(z.string()).optional(),
  /** The program input data encoded in a base-58 string. */
  data: z.string().optional(),
  stackHeight: z.number().nullable(),
})

export const instructionSchema = z.union([
  instructionDecodedSchema,
  instructionUndecodedSchema,
])

export type Instruction = z.infer<typeof instructionSchema>
